/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';

const Contact = () => {
  return (
    <div id="contact">
      <iframe title="contact-form" src="https://form.questionscout.com/5eb7a95cef487823f590a84d" name="myiFrame" scrolling="no" frameborder="0" marginheight="0px" marginwidth="0px" allowfullscreen></iframe>
    </div>
  );
}

export default Contact;
